import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import { CALENDLY_URL } from "@/components/Navbar";

export const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-cta-demo-button"
          className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 rounded-full bg-[linear-gradient(100deg,#00C6CC,#2FCB74)] px-6 py-4 text-sm font-bold text-white shadow-[0_20px_45px_-12px_rgba(0,190,200,0.7)] transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
          </span>
          <CalendarCheck size={17} />
          Réserver une démo
        </motion.a>
      )}
    </AnimatePresence>
  );
};
